<template>
  <div class="container section">

    <div class="alert alert-warning" v-show="notEnoughSpiff && accountAgents.length">
      <i class="fa fa-exclamation-circle"></i>&nbsp;&nbsp;
      <strong>Commission & Spiff Rate must equal 100!</strong>
    </div>

    <div class="row heading">
      <div class="col">
        <h2>Agents</h2>
      </div>
    </div>

    <div class="row table-head" >
      <div class="col-4">Agent Name</div>
      <div class="col text-right">Commission Rate</div>
      <div class="col text-right">Spiff Rate</div>
      <div class="col-3" v-if="!readonly">&nbsp;</div>
    </div>
    <div class="row lined" v-for="v, i in accountAgents" :key="v.user_id">
      <div class="col-4"  @click="setSelected(v);">
        <span v-show="!selected || selected.accountUser_id != v.accountUser_id" > {{ v.user_name }} </span>

        <span @click.stop="">

          <autocomplete
            @addClick="showAddAgent = true;"
            v-show="!v.accountUser_id || (selected.accountUser_id != null &&  selected.accountUser_id == v.accountUser_id)"
            :selection="selected.user_name"
            :list="agentNames"
            @change="setAgent"
            add
            addText="Create New Agent"
            placeholder="Search For An Agent"
          >
          </autocomplete>
        </span>
      </div>
      <div class="col text-right"  @click="setSelected(v)">
        <span v-show="(!selected || selected.accountUser_id != v.accountUser_id ) && v.accountUser_id" >
          {{v.commsrate}}%
        </span>
        <input
          v-show="!v.accountUser_id || ( selected && selected.accountUser_id == v.accountUser_id)"
          type="text"
          class="form-control"
          v-model.lazy="selected.commsrate"
        />
      </div>
      <div class="col text-right" @click="setSelected(v)">
        <span v-show="(!selected || selected.accountUser_id != v.accountUser_id ) && v.accountUser_id" >
          {{v.spiffrate}}%
        </span>
        <input
          v-show="!v.accountUser_id || ( selected && selected.accountUser_id == v.accountUser_id)"
          type="text"
          class="form-control"
          v-model.lazy="selected.spiffrate"
        />
      </div>
      <div class="col-3" v-if="!readonly">

        <div class="text-right" v-show="(!selected || selected.accountUser_id != v.accountUser_id ) && v.accountUser_id">
          <button class="btn btn-sm btn-light" v-if="$store.getters.getUserRoles[8].rolesPermissions[11].state" @click="buyAgent = v"><i class="fa fa-dollar"></i></button>
          <router-link :to="'/agents/' + v.user_id" class="btn btn-sm btn-light" v-if="$store.getters.getUserRoles[8].rolesPermissions[11].state"><i class="fa fa-user"></i></router-link>
          <dropdown-confirmation @confirm="deleteAgent(v)" v-if="v.editable">
          </dropdown-confirmation>
        </div>

        <div class="text-right" v-show="!v.accountUser_id || ( selected && selected.accountUser_id == v.accountUser_id)">
          <button class="btn btn-sm btn-light" @click.stop="setAgentDetails(selected)"><i class="fa fa-list"></i></button>
          <button class="btn btn-sm btn-success" @click.stop="updateAgent(selected)"><i class="fa fa-check"></i></button>
          <button class="btn btn-sm btn-danger" @click.stop="cancel(selected)"><i class="fa fa-close"></i></button>
        </div>
      </div>
    </div>

    <div class="row" v-if="!readonly">
      <div class="col-sm">
        <a class="btn btn-primary" @click.prevent="addAgent" href="#" >
          <i class="fa fa-plus"></i> &nbsp;Add Agent</a>
      </div>
    </div>


    <modal v-if="buyAgent" allow-click-away="false">

      <div slot="header">
        <h3 class="modal-title d-inline d-flex justify-content-start">Buy Commissions</h3>
        <button type="button" class="btn btn-clear close-btn" @click="buyAgent = null">
          <i class="fa fa-remove"  />
        </button>
      </div>
      </h3>
      <buy-commissions slot="body" :userName="getAgentName(buyAgent)" @close="buyAgent = null" :agent="buyAgent" @refetch="$emit('fetchAccountAgents')"></buy-commissions>

    </modal>


    <modal v-if="showBuyCommissions" allow-click-away="false">

      <div slot="header">
        <h3 class="modal-title d-inline d-flex justify-content-start">Buy Commissions</h3>
        <button type="button" class="btn btn-clear close-btn" @click="buyAgent = null" >
          <i class="fa fa-remove" />
        </button>
      </div>

      <buy-commissions slot="body" :userName="getAgentName(buyAgent)" @close="buyAgent = null" :agent="buyAgent" @refetch="$emit('fetchAccountAgents')"></buy-commissions>

    </modal>


    <modal v-if="showAgentDetails" size="lg">

      <div slot="header">
        <h3 class="modal-title d-inline d-flex justify-content-start">Agent Commission Rates</h3>
        <button @click="showAgentDetails = false" type="button" class="btn btn-clear close-btn" ><i class="fa fa-remove"  /></button>
      </div>
      <div slot="body">

        <div class="row lined">
          <div class="col">
            Tier 1 Comms
          </div>
          <div class="col-2">
            {{ selectedAgentCommissionDetails.tier1_commsrate }}%
          </div>
          <div class="col">
            Tier 1 Spiff
          </div>
          <div class="col-2">
            {{ selectedAgentCommissionDetails.tier1_spiffrate }}%
          </div>
          <div class="col-2">
            <button class="btn btn-primary" @click="setCommRate(selectedAgentCommissionDetails.tier1_commsrate, selectedAgentCommissionDetails.tier1_spiffrate)">Use This Rate</button>
          </div>
        </div>

        <div class="row lined">
          <div class="col">
            Tier 2 Comms
          </div>
          <div class="col-2">
            {{ selectedAgentCommissionDetails.tier2_commsrate }}%
          </div>
          <div class="col">
            Tier 2 Spiff
          </div>
          <div class="col-2">
            {{ selectedAgentCommissionDetails.tier2_spiffrate }}%
          </div>
          <div class="col-2">
            <button class="btn btn-primary" @click="setCommRate(selectedAgentCommissionDetails.tier2_commsrate, selectedAgentCommissionDetails.tier2_spiffrate)">Use This Rate</button>
          </div>
        </div>


        <div class="row lined">
          <div class="col">
            Tier 3 Comms
          </div>
          <div class="col-2">
            {{ selectedAgentCommissionDetails.tier3_commsrate }}%
          </div>
          <div class="col">
            Tier 3 Spiff
          </div>
          <div class="col-2">
            {{ selectedAgentCommissionDetails.tier3_spiffrate }}%
          </div>
          <div class="col-2">
            <button class="btn btn-primary" @click="setCommRate(selectedAgentCommissionDetails.tier3_commsrate, selectedAgentCommissionDetails.tier3_spiffrate)">Use This Rate</button>
          </div>
        </div>


        <div class="row">
          <div class="col">
            Tier 4 Comms
          </div>
          <div class="col-2">
            {{ selectedAgentCommissionDetails.tier4_commsrate }}%
          </div>
          <div class="col">
            Tier 4 Spiff
          </div>
          <div class="col-2">
            {{ selectedAgentCommissionDetails.tier4_spiffrate }}%
          </div>
          <div class="col-2">
            <button class="btn btn-primary" @click="setCommRate(selectedAgentCommissionDetails.tier4_commsrate, selectedAgentCommissionDetails.tier4_spiffrate)">Use This Rate</button>
          </div>
        </div>

      </div>

    </modal>



    <modal v-if="showAddAgent" size="lg">
      <div slot="header">
        <h3 class="modal-title d-inline d-flex justify-content-start">Add Agent</h3>
        <button @click="showAddAgent = false"  type="button" class="btn btn-clear close-btn" >
          <i class="fa fa-remove" />
        </button>
        </h3>
      </div>
      <add-agent slot="body" @close="showAddAgent = false" stay @saved="setNewAgent"></add-agent>
    </modal>


  </div>
</template>
<script type="text/babel">
  import Dropdown from '../assets/Dropdown.vue';
  import DropdownConfirmation from '../assets/DropdownConfirmation.vue';
  import Autocomplete  from '../assets/Autocomplete.vue';
  import Modal  from '../assets/Modal.vue';
  import BuyCommissions  from './BuyCommissions.vue';
  import AddAgent  from '../agents/AddAgent.vue';
  export default {
    name: 'AccountAgents',
    data: function(){
      return {
        params: {
          data: {
            account_id: ''
          }
        },
        selected: {
          accountUser_id: '',
          user_id: '',
          user_name: '',
          commsrate: '',
          spiffrate: '',
          editable: null
        },
        newagent:{
          accountUser_id: '',
          user_id: '',
          user_name: '',
          commsrate: '',
          spiffrate: ''
        },
        agents:[],
        showBuyCommissions: false,
        buyAgent: null,
        showAddAgent: false,
        showAgentDetails: false,
        accountAgents: [],
        selectedAgentCommissionDetails:{}
      }
    },

    created(){
      this.params.data.account_id = this.account_id;
      this.fetchAgents();
      this.fetchAccountAgents();
    },
    computed:{
      notEnoughSpiff(){

        var totalSpiff = this.accountAgents.reduce(function(a, b){
            return a + parseFloat(b.spiffrate)
        }, 0);
        var totalCommission = this.accountAgents.reduce(function(a, b){
          return a + parseFloat(b.commsrate);
        }, 0);

        return totalCommission != 100 || totalSpiff != 100;
      },
      agentNames(){
        return this.agents.map(function(agent){
          return agent.name;
        });
      }
    },
    components:{
      Autocomplete,
      AddAgent,
      Dropdown,
      DropdownConfirmation,
      Modal,
      BuyCommissions
    },
    methods:{

      setNewAgent(agent){

        this.selected.user_id = agent.user_id;
        this.selected.user_name = agent.name;
        this.fetchAgents();
      },
      setCommRate(comm, spiff){
        this.selected.commsrate = comm;
        this.selected.spiffrate = spiff;
        this.showAgentDetails = false;
        this.selectedAgentCommissionDetails = {};
      },
      setAgentDetails(selected){
        var _this = this;
        this.$send(this, 'userCommissions', {
          user_id: selected.user_id
        }).then(r => {

          var details = r.userCommissions.carriers.filter(c => c.carrier_id == _this.carrier_id );
          if(!details.length) {
            this.selectedAgentCommissionDetails = r.userCommissions.default;
          } else {
            this.selectedAgentCommissionDetails = details[0];
          }
          this.showAgentDetails = true;

        });
      },
      getAgentName(u){

          var agent_id = u.user_id;
          var username = this.agents.filter(function(agent){
            return agent.user_id == agent_id;
          }).map(function(agent){
            return agent.name;
          });

          if(username.length) return username[0];
          return '';

      },

      cancel(selected){

        if(this.accountAgents.length && !this.accountAgents[ this.accountAgents.length - 1 ].accountUser_id){
          this.accountAgents.splice(-1);
        }
        this.selected = {
            accountUser_id: '',
            user_id: '',
            user_name: '',
            commsrate: '',
            spiffrate: '',
            editable: null
        };
      },

      addAgent(){
        this.cancel();
        this.accountAgents.push({
          user_id: '',
          commsrate: 0,
          user_name: '',
          spiffrate: 0,
          editable: true
        });
      },

      setSelected(v){

        if(v.accountUser_id && this.selected.accountUser_id != v.accountUser_id && v.editable && !this.readonly){
          this.cancel();
          this.selected = JSON.parse(JSON.stringify(v));
        }
      },

//      reloadAgents(agent){
//        this.fetchAccountAgents();
//        this.fetchAgents();
//        this.selected.user_name = user_name.name;
//        this.selected.user_id = user_name.user_id;
//        this.showAddAgent = false;
//      },

      setAgent(value){

        if(!value) {
          this.selected.user_name = '';
          this.selected.user_id = '';
          return;
        }

        var agent_id = this.agents.filter(function(agent){
          return agent.name == value;
        }).map(function(agent){
          return agent.user_id;
        });


        if(agent_id.length){
          this.selected.user_id = agent_id[0];
          this.selected.user_name = value;
        } else {
          this.selected.user_id = '';
          this.selected.user_name = '';
        }

      },
      updateAgent(i){

        this.selected.account_id = this.params.data.account_id;

        var fn = (this.selected.accountUser_id)? 'accountUserUpdate': 'accountUserCreate';

        this.$send(this, fn,  this.selected).then(r => {
          if(fn == 'accountUserCreate'){
            this.fetchAccountAgents();
          } else {
            var index = this.accountAgents.findIndex( v => v.accountUser_id === this.selected.accountUser_id );
            this.accountAgents.splice(index, 1, this.selected);
          }
          if(fn == 'accountUserCreate') this.fetchAccountAgents();
          this.selected = {};
        });


        this.$emit( 'accountUserUpdate', this.selected );
        this.$nextTick(function(){

        });
      },

      deleteAgent(u){
        this.$send(this, 'accountUserDelete', {
          accountUser_id: u.accountUser_id
        }).then(r => {
          this.fetchAccountAgents();
        });
      },

      fetchAgents(){
        this.$send(this, 'userUsers').then(r => {

          this.agents = r.userUsers || [];
        });
        this.showAddAgent = false;
      },

      fetchAccountAgents(){
        this.$send(this, 'accountUsers',  this.params.data).then(r => {
          this.accountAgents = r.accountUsers;
        });
      }

    },
    props:{
      account_id: {
        type: String
      },

      readonly:{
        type: Boolean,
        default: false
      }
    }

  }

</script>

<style scoped>
  .modal-body .container.section {
    box-shadow: none;
    padding: 0 5px;
  }

  .modal-body .row.heading {
    display: none;
  }
  
</style>




// WEBPACK FOOTER //
// AccountAgents.vue?cfb79fa6